import React from "react";
import flechaAvanzar from "../assets/right-arrow.svg";

const TEXT_CLASS = {
  orange: "orange",
  violet: "violet",
  blue: "blue",
  green: "green",
};

const BG_CLASS = {
  orange: "bgOrange",
  violet: "bgViolet",
  blue: "bgBlue",
  green: "bgGreen",
};

function CheckButton({
  text = "Confirmar",
  onClick,
  className = "",
  disabled = false,
  size = 60,
  ariaLabel,
  iconSrc = flechaAvanzar,
  color,
  loading = false,
  /** Sin panel claro semitransparente (pantallas oscuras tipo start-game / escenario 2). */
  bare = false,
}) {
  const textClass = color ? TEXT_CLASS[color] || "" : "txtRed";
  const btnBgClass = color ? BG_CLASS[color] || "" : "";

  const panelStyle = bare
    ? undefined
    : { backgroundColor: "#FFFFFFCC", paddingLeft: "20px", borderRadius: "15px" };

  return (
    <div
      className={`d-flex justify-content-end align-items-center ${className}`}
      style={panelStyle}
    >
      <div className={`txt20 bold me-3 ${textClass}`}>{text}</div>
      <button
        onClick={onClick}
        className={`btn-main btn-progress ${btnBgClass} ${textClass}`}  // <-- importante
        disabled={disabled || loading}
        data-loading={loading ? "true" : "false"}                      // <-- spinner activo
        aria-label={ariaLabel || text}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: "50%",
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        <img
          src={iconSrc}
          alt=""
          style={{ maxWidth: `${Math.round(size * 0.5)}px` }}
        />
      </button>
    </div>
  );
}

export default CheckButton;
